/**
 * Tax calculation functions
 */

/**
 * Calculate VAT amount and VAT-inclusive revenue
 * 
 * @param grossRevenue - Gross revenue (VAT-exclusive)
 * @param vatRate - VAT rate as decimal (e.g., 0.20 for 20%)
 * @returns Object with VAT amount and VAT-inclusive revenue
 */
export function calculateVAT(
  grossRevenue: number,
  vatRate: number
): { vatAmount: number; vatInclusiveRevenue: number } {
  const vatAmount = grossRevenue * vatRate;
  const vatInclusiveRevenue = grossRevenue + vatAmount;
  
  return {
    vatAmount,
    vatInclusiveRevenue,
  };
}

/**
 * Calculate withholding tax amount and net revenue after withholding
 * 
 * @param grossRevenue - Gross revenue before withholding
 * @param rate - Withholding tax rate as decimal (e.g., 0.04 for 4%)
 * @returns Object with withholding amount and net revenue
 */
export function calculateWitholdingTax(
  grossRevenue: number,
  rate: number
): { witholdingAmount: number; netRevenue: number } {
  const witholdingAmount = grossRevenue * rate;
  const netRevenue = grossRevenue - witholdingAmount;
  
  return {
    witholdingAmount,
    netRevenue,
  };
}
